import { lazy } from "react";
import { Navigate, Outlet } from "react-router";

const PartiesTools = lazy(() => import("./parties-tools/components/PartiesTools"));
const SettlementTasks = lazy(() => import("./settlement-tasks/components/SettlementTasks"));
const PleadingsTools = lazy(() => import("./pleadings-tools/components/PleadingsTools"));
const IDVerification = lazy(() => import("./id-verification/components/IDVerification"));
const DisbursementTracker = lazy(() => import("./disbursement-tracker/DisbursementTracker"));
const docgenRoutes = [
  { index: true, element: <Navigate to={process.env.PUBLIC_URL} /> },
  { path: "parties-tools/:projectId/:partyType", element: <PartiesTools /> },
  { path: "settlement-tasks/:projectId/:taskType", element: <SettlementTasks /> },
  {
    path: "pleadings-tools/:projectId/:projectType",
    element: <Outlet />,
    children: [{ path: ":tool", element: <PleadingsTools /> }],
  },
  { path: "id-verification/*", element: <IDVerification /> },
  { path: "disbursement-tracker/:projectId", element: <DisbursementTracker /> },
];

export default docgenRoutes;
